// extracted by mini-css-extract-plugin
export default {"checkboxwrapper":"BooleanPropertyInput_checkboxwrapper__G5LV2"};